'use client';

import { Suspense } from 'react';
import { useAnalytics } from '../../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../../helpers/analytics/trackEvent';
import { useCurrentURL } from '../../../../../helpers/hooks/useCurrentURL/useCurrentURL';
import { flowsURLParameters, URLParameters } from '../../../../../views/Authentication/constants';
import {
  IInternalLinkProps,
  NonCrawlableLink,
} from '../../../../Clickables/NonCrawlableLink/NonCrawlableLink';
import { getVariantClass } from '../../../../Clickables/variants';

const SuspendedLoginButton = ({
  onClick,
  buttonSize,
  className,
}: {
  onClick: () => void;
  buttonSize: IInternalLinkProps['size'];
  className?: string;
}) => {
  const { addParameters } = useCurrentURL();
  const loginLink = addParameters({ [URLParameters.Flow]: flowsURLParameters.login });
  return (
    <NonCrawlableLink
      variant="buttonSecondary"
      size={buttonSize}
      className={className}
      routerPushTo={loginLink}
      onClickEvent={onClick}
      ariaLabel="log in to Fishbrain"
    >
      Log in
    </NonCrawlableLink>
  );
};

const LoginButtonFallback = ({
  buttonSize = 'default',
  className,
}: {
  buttonSize?: IInternalLinkProps['size'];
  className?: string;
}) => {
  return (
    <div
      className={`${className} ${getVariantClass('buttonSecondary', buttonSize)}`}
      aria-label="log in to Fishbrain"
    >
      Log in
    </div>
  );
};

export const LoginButton = ({
  buttonSize = 'default',
  className,
}: {
  buttonSize?: IInternalLinkProps['size'];
  className?: string;
}) => {
  const { currentPage } = useAnalytics();
  return (
    <Suspense fallback={<LoginButtonFallback buttonSize={buttonSize} className={className} />}>
      <SuspendedLoginButton
        buttonSize={buttonSize}
        className={className}
        onClick={() => {
          void trackEvent({
            name: 'mykiss_hamburger_clicked',
            properties: { action: 'navigate', source: currentPage },
          });
        }}
      />
    </Suspense>
  );
};
